import { SeoData } from "./interfaces/seo.types";
import { Commons } from './Commons';
import { environment } from "../../environments/environment";

export class CustomMetaData {
  static readonly HOME: SeoData = {
    title: `${environment.dfConfigCompanyName} | ${environment.dfConfigSlogan}`,
    description: `${environment.dfConfigAbout}`,
    canonicalPath: '/',
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: true
  };

  static readonly ABOUT: SeoData = {
    title: `Sobre Nosotros | ${environment.dfConfigCompanyName}`,
    description: `Conoce nuestra historia en ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_ABOUT}`,
    index: environment.home.about_us === 'page'
  };

  static readonly TEAM: SeoData = {
    title: `Nuestro Equipo de Profesionales | ${environment.dfConfigCompanyName}`,
    description: `Conoce al equipo de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_TEAM}`,
    index: environment.home.team === 'page'
  };

  static readonly CONTACT: SeoData = {
    title: `Contáctanos | ${environment.dfConfigCompanyName}`,
    description: `Ponte en contacto con ${environment.dfConfigCompanyName} para consultas y más información sobre nuestro servicio.`,
    canonicalPath: `/${Commons.PATH_CONTACT}`,
    index: environment.home.contact === 'page'
  };

  static readonly SERVICES: SeoData = {
    title: `Servicios | ${environment.dfConfigCompanyName}`,
    description: `Descubre los servicios de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_SERVICES}`,
    index: environment.home.services === 'page'
  };

  static readonly LOCATION: SeoData = {
    title: `Ubicación y Cómo Llegar | ${environment.dfConfigCompanyName}`,
    description: `Encuentra ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_LOCATION}`,
    index: environment.home.map === 'page'
  };

  static readonly PUBLICATIONS: SeoData = {
    title: `Noticias y Publicaciones | ${environment.dfConfigCompanyName}`,
    description: `Lee las últimas noticias y publicaciones de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_PUBLICATIONS}`,
    index: environment.home.publications === 'page'
  };

  static readonly GALLERY: SeoData = {
    title: `Galería de Imágenes | ${environment.dfConfigCompanyName}`,
    description: `Explora la galería de fotos de ${environment.dfConfigCompanyName}`,
    canonicalPath: `/${Commons.PATH_GALLERY}`,
    index: environment.home.gallery === 'page'
  };

  /* BEGIN | CUSTOM SERVICE SEO — actualizar title, description y canonicalPath por cliente */
  static readonly SERVICE_1: SeoData = {
    title: `Servicio 1 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 1 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-1`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };

  static readonly SERVICE_2: SeoData = {
    title: `Servicio 2 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 2 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-2`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };

  static readonly SERVICE_3: SeoData = {
    title: `Servicio 3 | ${environment.dfConfigCompanyName}`,
    description: `Conoce en detalle el Servicio 3 de ${environment.dfConfigCompanyName}: beneficios, proceso de trabajo y cómo puede ayudarte.`,
    canonicalPath: `/${Commons.PATH_SERVICES}/service-3`,
    meta: [
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: environment.home.services === 'page'
  };
  /* END | CUSTOM SERVICE SEO */

  static readonly DESIGN: SeoData = {
    title: `Diseño de sitios web profesionales | Publinex`,
    description: `Creamos sitios web modernos, optimizados para SEO y dispositivos móviles.
                  Aumenta tu visibilidad online y atrae más clientes con Publinex, tu aliado en diseño web.`,
    canonicalPath: '/web-sites-design',
    meta: [
      { name: 'keywords', content: 'diseño de sitios web, desarrollo web, páginas web Chile, sitios web profesionales, SEO, Publinex' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Diseño de sitios web profesionales | Publinex' },
      { property: 'og:description', content: 'Creamos sitios web optimizados para SEO y móviles. Con Publinex, potencia tu negocio con un diseño web moderno y escalable.' },
      { property: 'og:url', content: `${environment.baseUrl}/web-sites-design` },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Diseño de sitios web profesionales | Publinex' },
      { name: 'twitter:description', content: 'Sitios web modernos, rápidos y optimizados para SEO. Haz crecer tu negocio con Publinex.' },
      { name: 'twitter:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: true
  };


  static readonly BUILD: SeoData = {
    title: `Sitios web escalables según tus necesidades | Publinex`,
    description: `Desarrollamos sitios web escalables, seguros y de alto rendimiento.
                  Publinex adapta tu proyecto a tus necesidades para que crezca junto a tu negocio.`,
    canonicalPath: '/web-sites-build',
    meta: [
      { name: 'keywords', content: 'sitios web escalables, desarrollo web a medida, aplicaciones web, Publinex, páginas web profesionales, hosting seguro' },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Sitios web escalables según tus necesidades | Publinex' },
      { property: 'og:description', content: 'Creamos sitios web seguros y de alto rendimiento, pensados para crecer con tu negocio. Publinex: tu socio en desarrollo web.' },
      { property: 'og:url', content: `${environment.baseUrl}/web-sites-build` },
      { property: 'og:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Sitios web escalables según tus necesidades | Publinex' },
      { name: 'twitter:description', content: 'Desarrollamos sitios web a medida, optimizados y escalables. Haz crecer tu negocio con Publinex.' },
      { name: 'twitter:image', content: `${environment.baseUrl}/assets/img/png/company_logo_df.png` }
    ],
    index: true
  };

  // TODO: crea la variable estatica para la pagina VERSIONS acá




}
